import { render, staticRenderFns } from "./FaultDetections.vue?vue&type=template&id=84e745b2&scoped=true"
import script from "./FaultDetections.vue?vue&type=script&lang=js"
export * from "./FaultDetections.vue?vue&type=script&lang=js"
import style0 from "./FaultDetections.vue?vue&type=style&index=0&id=84e745b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e745b2",
  null
  
)

export default component.exports